require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-customer-loyalty.json") })
        }
      }, "path---authors-customer-loyalty");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-customer-loyalty!./.cache/json/authors-customer-loyalty.json
// module id = 1270
// module chunks = 231608221292675